import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Typography, Button, Chip, ButtonGroup } from '@material-ui/core';
import axios from 'axios';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import SendIcon from '@material-ui/icons/Send';
import NearMeIcon from '@material-ui/icons/NearMe';
import Skeleton from '@material-ui/lab/Skeleton';
import { encryptData } from '../../../utils/CryptoHandler';
export function HomeDashboard(props) {



  const [loading, setLoading] = useState({
    balance: false,
    totalTx: false,
    balanceLink: false,
    balanceTxMonth: false
  });

  const [loadingBalance, setLoadingBalance] = useState(false);
  const [loadingTotalTx, setLoadingTotalTx] = useState(false);
  const [loadingBalanceLink, setLoadingBalanceLink] = useState(false);
  const [loadingBalanceTxMonth, setLoadingBalanceTxMonth] = useState(false);

  const [searchType, setSearchType] = useState(1)
  const [balanceTx, setBalanceTx] = useState(0);
  const [totalTx, setTotalTx] = useState({
    total: 0,
    completadas: 0,
    rechazadas: 0

  });

  const [balanceLink, setBalanceLink] = useState({
    no_pagados: 0,
    pagados: 0,
    enviados: 0,
    porcentaje: 0,
    canales: 0,
    status_detalle: 0

  });

  const [balanceTxMonth, setBalanceTxMonth] = useState([]);


  useEffect(() => {
    if (props.id_empresa !== undefined && props.id_empresa !== null) {
      getBalanceTx()

    }


  }, [searchType, props.id_empresa])


  useEffect(() => {
    if (props.id_empresa !== undefined && props.id_empresa !== null) {
      getTotalTx()
      getBalanceTxMonth()
    }
  }, [props.id_empresa])
  // Efecto para obtener el balance de enlaces al montar el componente

  useEffect(() => {

    if (props.id_usuario !== undefined && props.id_usuario !== null) {
      getBalanceLink()
    }

  }, [props.id_usuario])

  const getBalanceLink = async () => {
    // Aquí podrías implementar la lógica para obtener el balance de enlaces
    
    setLoadingBalanceLink(true)
    try {
      let result = await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_GET_BALANCE_LINK,
        {
          id_user_plink: props.id_usuario,
        },
        {
          headers: {
            'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
            'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
          }
        }
      )
      
      if (result.data.exito) {
        setLoadingBalanceLink(false)
        setBalanceLink({
          no_pagados: [...new Set(result.data.no_pagadas.filter(no_pagado => !result.data.aprobadas.includes(no_pagado)))],
          pagados: result.data.aprobadas,
          enviados: result.data.total,
          porcentaje: result.data.porcentaje,
          canales: result.data.canales_envio,
          status_detalle: result.data.status_detail

        });
      } else {
        setLoadingBalanceLink(false)
        setBalanceLink({
          no_pagados: 0,
          pagados: 0,
          enviados: 0,
          porcentaje: 0,
          canales: 0,
          status_detalle: 0

        });
      }
    } catch (error) {
      setLoadingBalanceLink(false)
      console.error("Error al obtener balance de enlaces:", error);
      // Manejo de errores, por ejemplo, mostrar un mensaje al usuario

    }
  }

  const getBalanceTxMonth = async () => {
    
    setLoadingBalanceTxMonth(true)
    try {
      let result = await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_GET_MONTHLY_TX,
        {
          id_empresa: props.id_empresa,
        }, {
        headers: {
          'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
          'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
        }
      })
      
      if (result.data.exito) {
        setLoadingBalanceTxMonth(false)

        setBalanceTxMonth(result.data.data)
      } else {
        setLoadingBalanceTxMonth(false)
        setBalanceTxMonth([])
      }
    } catch (error) {
      setLoadingBalanceTxMonth(false)
      console.error("Error al obtener balance de transacciones del mes:", error);
      // Manejo de errores, por ejemplo, mostrar un mensaje al usuario
    }
  }

  const getBalanceTx = async () => {
    // Aquí podrías implementar la lógica para obtener el balance de transacciones
    
    setLoadingBalance(true)
    try {
      let result = await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_GET_BALANCE_TX,
        {
          id_empresa: props.id_empresa,
          tipo_busqueda: searchType
        }, {
        headers: {
          'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
          'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
        }
      })
      
      if (result.data.exito) {
        setLoadingBalance(false)
        setBalanceTx(result.data.balance);
      } else {
        setLoadingBalance(false)
        setBalanceTx(0);
      }
    } catch (error) {
      setLoadingBalance(false)
      console.error("Error al obtener balance de transacciones:", error);
      // Manejo de errores, por ejemplo, mostrar un mensaje al usuario

    }
  }

  const getTotalTx = async () => {
    setLoadingTotalTx(true)

    try {

      let result = await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_GET_TOTAL_TX,
        {
          id_empresa: props.id_empresa,
        }, {
        headers: {
          'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
          'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
        }
      })
      
      if (result.data.exito) {
        setLoadingTotalTx(false)
        setTotalTx(
          {
            total: result.data.total,
            completadas: result.data.aprobadas,
            rechazadas: result.data.rechazadas
          }
        );
      } else {
        setLoadingTotalTx(false)
        setTotalTx(
          {
            total: 0,
            completadas: 0,
            rechazadas: 0
          }
        );
      }
    } catch (error) {
      setLoadingTotalTx(false)
      console.error("Error al obtener total de transacciones:", error);
      // Manejo de errores, por ejemplo, mostrar un mensaje al usuario

    }
  }

  const handlerChangeSearchType = (type) => {
    setSearchType(type);
    getBalanceTx();
  }

  return (
    <Box p={1}>
      {/* Primera fila: Balance, Enlaces, Transacciones */}
      {}
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa" }}>
            <Typography variant="h6"> {loadingBalance ? <Skeleton variant="h6" width="100%" height={20} /> : "Balance Bs."}</Typography>
            <Box display="flex" alignItems="center" mt={1}>
              <Typography variant="h5" style={{ fontWeight: "bold", marginRight: 8 }}>{loadingBalance ? <Skeleton variant="h5" width="100%" height={20} /> : balanceTx}</Typography>
              <Box ml={2}>

                <ButtonGroup disableElevation variant="contained" color="primary">

                  {loadingBalance ? <Skeleton variant="h6" width="100%" height={20} /> :
                    <>
                      <Button size="small" onClick={(e) => { handlerChangeSearchType(1) }} style={{ background: searchType === 1 ? "#a39be6" : "#eee", color: searchType === 1 ? "#fff" : "#888", minWidth: 40 }}>Mes</Button>
                      <Button size="small" onClick={(e) => { handlerChangeSearchType(2) }} style={{ background: searchType === 2 ? "#a39be6" : "#eee", color: searchType === 2 ? "#fff" : "#888", minWidth: 40 }}>Trimestre</Button>
                    </>
                  }


                </ButtonGroup>

              </Box>
            </Box>
            <Typography variant="subtitle2" color="textSecondary">{loadingBalance ? <Skeleton variant="subtitle2" width="100%" height={20} /> : "Total recaudado"}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa" }}>
            <Typography variant="h6"> {loadingBalanceLink ? <Skeleton variant="h6" width="100%" height={20} /> : "Enlaces"} </Typography>

            <Box display="flex" flexDirection="row">
              <Box display="flex" flexDirection="column" mt={0.8}>
                <Typography variant="body2" color="textSecondary"> {loadingBalanceLink ? <Skeleton variant="text" width="10%" height={20} /> : "Enviados"}</Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                {loadingBalanceLink ? <Skeleton variant="circle" width={40} height={40} /> : <SendIcon fontSize='small' style={{ marginLeft: 10, transform: 'rotate(-45deg)' }} />}

              </Box>
              <Box display='flex' flexDirection='column'>
                <Typography variant="h5" style={{ fontWeight: "bold", marginLeft: 10 }}>{loadingBalanceLink ? <Skeleton variant="text" width={40} height={40} /> : balanceLink.enviados}</Typography>
              </Box>
            </Box>

            {/* <Box display="flex" alignItems="center" mt={1}>
              <Typography variant="subtitle2" color="textSecondary" style={{ marginRight: 8 }}>Enviados</Typography>
              <span role="img" aria-label="enviado" style={{ fontSize: 22, marginRight: 8 }}>✈️</span>
              <Typography variant="h5" style={{ fontWeight: "bold" }}>{balanceLink.enviados}</Typography>
            </Box> */}
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa" }}>
            <Typography variant="h6">{loadingTotalTx ? <Skeleton variant="text" width="100%" height={40} /> : <>Transacciones <span style={{ fontWeight: "bold" }}>{totalTx.total}</span></>}</Typography>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Box>
                <Typography variant="caption" color="textSecondary">{loadingTotalTx ? <Skeleton variant="text" width="70%" height={20} /> : "Completadas"}</Typography>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>{loadingTotalTx ? <Skeleton variant="text" width="100%" height={20} /> : totalTx.completadas}</Typography>
              </Box>
              <Box>
                <Typography variant="caption" color="textSecondary">{loadingTotalTx ? <Skeleton variant="text" width="70%" height={20} /> : "Rechazadas"}</Typography>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>{loadingTotalTx ? <Skeleton variant="text" width="70%" height={20} /> : totalTx.rechazadas}</Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Segunda fila: Conversión y Gráfica */}
      <Grid container spacing={2} style={{ marginTop: 12 }}>
        <Grid item xs={12} md={4}>




          <Paper elevation={0} style={{ borderRadius: 20, padding: 32, background: "#fafafa", height: "100%" }}>
            <Typography variant="subtitle1" align="center" color="textSecondary"> {loadingBalanceLink ? <Skeleton variant="subtitle1" width="100%" height={20} /> : "Tasa de conversión : Links"}</Typography>
            <Typography variant="h2" align="center" style={{ fontWeight: "bold", margin: "24px 0" }}>{loadingBalanceLink ? <Skeleton variant="h2" width="100%" height={40} style={{ margin: "24px 0" }} a /> : balanceLink.porcentaje ? balanceLink.porcentaje.toFixed(2) + "%" : 0.00 + "%"}</Typography>
            <Box display="flex" justifyContent="space-between" mt={4}>
              <Box textAlign="center" flex={1}>
                <Typography variant="caption" color="textSecondary"> {loadingBalanceLink ? <Skeleton variant="caption" width="100%" height={20} /> : "Enlaces enviados"}</Typography>
                <Typography variant="h5" style={{ color: "#6c63ff", fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="h5" width="100%" height={20} /> : balanceLink.enviados}</Typography>
              </Box>

              {loadingBalanceLink ? <Skeleton variant="h5" width={2} height={20} /> : <Box borderLeft="1px solid #ccc" mx={2} />}
              <Box textAlign="center" flex={1}>
                <Typography variant="caption" color="textSecondary"> {loadingBalanceLink ? <Skeleton variant="caption" width="100%" height={20} /> : "Enlaces pagados"}</Typography>
                <Typography variant="h5" style={{ color: "#6c63ff", fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="h5" width="100%" height={20} /> : balanceLink.pagados.length}</Typography>
              </Box>
            </Box>
          </Paper>

        </Grid>


        <Grid item xs={12} md={8}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa", height: "100%" }}>
            {/* Aquí va tu componente de gráfica */}
            <Box height={220} display="flex" alignItems="center" justifyContent="center" color="#aaa">
              <ResponsiveContainer width={"100%"} height={250}>
                {
                  loadingBalanceTxMonth ?
                    <Skeleton variant="rect" width="100px" height={5} />
                    :
                    // balanceTxMonth.length === 0 ?
                    //   (
                    //     // Display a message if no data
                    //     <div style={{
                    //       textAlign: 'center',
                    //       padding: '50px 20px',
                    //       color: '#555',
                    //       fontSize: '1.2em',
                    //       border: '1px dashed #ccc',
                    //       borderRadius: '8px',
                    //       margin: '20px 0',
                    //       height: '200px'
                    //     }}>
                    //       <Typography variant="body2" color="textSecondary" align="center">No hay datos disponibles para este mes.</Typography>
                    //     </div>
                    //   )



                    <BarChart
                      data={balanceTxMonth}
                      margin={{
                        top: 40,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="4 4" />
                      <XAxis dataKey="mes" />
                      <YAxis />
                      <Tooltip />

                      <Bar dataKey="aprobadas" stackId="a" fill="#4A37ED" radius={[0, 0, 0, 0]} />
                      <Bar dataKey="rechazadas" stackId="a" fill="#7678F7" radius={[10, 10, 0, 0]} />
                    </BarChart>
                }

              </ResponsiveContainer>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Tercera fila: Enlaces por falta de pago y Canales */}
      <Grid container spacing={2} style={{ marginTop: 12 }}>
        <Grid item xs={12} md={4}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa" }}>
            <Typography variant="h6">{loadingBalanceLink ? <Skeleton variant="h5" width="100%" height={20} /> : "Enlaces"}</Typography>
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" mt={2}>
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2" style={{ color: "red" }}>{loadingBalanceLink ? <Skeleton variant="text" width="50%" height={20} /> : "Por falta de pago"}</Typography>
                <Typography variant="h5" style={{ fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="text" width="50%" height={20} /> : balanceLink.no_pagados.length}</Typography>
              </Box>
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2" style={{ color: "red" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : "Enlaces vencidos"}</Typography>
                <Typography variant="h5" style={{ fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : balanceLink.status_detalle.total_vencidos ? balanceLink.status_detalle.total_vencidos : 0}</Typography>
              </Box>


            </Box>

            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" mt={2}>
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2" style={{ color: "green" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : "Enlaces vistos"}</Typography>
                <Typography variant="h5" style={{ fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : balanceLink.status_detalle.total_vistos ? balanceLink.status_detalle.total_vistos : 0}</Typography>
              </Box>

              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2" style={{ color: "#ff9800" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : "Enlaces no vistos"}</Typography>
                <Typography variant="h5" style={{ fontWeight: "bold" }}>{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : balanceLink.status_detalle.total_no_vistos ? balanceLink.status_detalle.total_no_vistos : 0}</Typography>
              </Box>
            </Box>


          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper elevation={0} style={{ borderRadius: 20, padding: 24, background: "#fafafa" }}>
            <Typography variant="h6">{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={40} /> : "Canales"}</Typography>

            <Box display="flex" flexDirection="row">
              <Box display="flex" flexDirection="column" mt={0.8}>
                <Typography variant="body2" color="textSecondary">{loadingBalanceLink ? <Skeleton variant="text" width="100%" height={20} /> : "De envío"} </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                {loadingBalanceLink ? <Skeleton variant="circle" width={40} height={40} /> : <SendIcon fontSize='small' style={{ marginLeft: 10, transform: 'rotate(-45deg)' }} />}
              </Box>
            </Box>


            <Box display="flex" alignItems="center" mt={2}>
              {loadingBalanceLink ? <Skeleton variant="circle" width={40} height={40} /> : <Chip label="Email" style={{ background: "#ff9800", color: "#fff", marginRight: 8 }} />}
              <Typography variant="h6" style={{ marginRight: 24 }}>{loadingBalanceLink ? <Skeleton variant="text" width={40} height={40} /> : balanceLink.canales.total_canal_1 ? balanceLink.canales.total_canal_1 : 0}</Typography>
              {loadingBalanceLink ? <Skeleton variant="circle" width={40} height={40} /> : <Chip label="WhatsApp" style={{ background: "#4caf50", color: "#fff", marginRight: 8 }} />}
              <Typography variant="h6">{loadingBalanceLink ? <Skeleton variant="circle" width={40} height={40} /> : balanceLink.canales.total_canal_2 ? balanceLink.canales.total_canal_2 : 0}</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

// Agrega este export default:
export default HomeDashboard;